import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzSpaceModule } from 'ng-zorro-antd/space';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NzMessageModule, NzMessageService } from 'ng-zorro-antd/message';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzSwitchModule } from 'ng-zorro-antd/switch';
import { CopyToClipboardComponent } from '../components/copy-to-clipboard/copy-to-clipboard.component';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { OperatorDropdownComponent } from '../components/operator-dropdown/operator-dropdown.component';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown'; 
import { MerchantDropdownComponent } from '../components/merchant-dropdown/merchant-dropdown.component';
import { NzAutocompleteModule } from 'ng-zorro-antd/auto-complete';
import { FormsModule } from '@angular/forms';
import { PackagesComponent } from '../components/plans/packages.component';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzRadioModule } from 'ng-zorro-antd/radio';

@NgModule({
  declarations: [
    CopyToClipboardComponent,
    OperatorDropdownComponent,
    MerchantDropdownComponent,
    PackagesComponent
  ],
  imports: [
    CommonModule,
    NzProgressModule,
    NzSpaceModule,
    NzGridModule,
    NzMessageModule,
    NzModalModule,
    NzInputModule,
    NzIconModule,
    NzButtonModule,
    NzDividerModule,
    NzTagModule,
    NzTableModule,
    NzSelectModule,
    NzPopconfirmModule,
    NzToolTipModule,
    NzSwitchModule,
    NzBadgeModule,
    NzAlertModule,
    NzDropDownModule,
    NzAutocompleteModule,
    FormsModule,
    NzCheckboxModule,
    NzDatePickerModule,
    NzRadioModule
  ],
  exports: [
    NzProgressModule,
    NzSpaceModule,
    NzGridModule,
    NzMessageModule,
    NzModalModule,
    NzInputModule,
    NzIconModule,
    NzButtonModule,
    NzDividerModule,
    NzTagModule,
    NzTableModule,
    NzSelectModule,
    NzPopconfirmModule,
    NzToolTipModule,
    NzSwitchModule,
    CopyToClipboardComponent,
    NzBadgeModule,
    NzAlertModule,
    OperatorDropdownComponent,
    NzDropDownModule,
    MerchantDropdownComponent,
    NzAutocompleteModule,
    PackagesComponent,
    NzCheckboxModule,
    NzDatePickerModule,
    NzRadioModule
  ],
  providers:[
    NzMessageService
  ]
})
export class AppCommonModule { }
